import { render } from "./ForwardToAppraiser.vue?vue&type=template&id=8200271a&scoped=true"
import script from "./ForwardToAppraiser.vue?vue&type=script&lang=js"
export * from "./ForwardToAppraiser.vue?vue&type=script&lang=js"

import "./ForwardToAppraiser.vue?vue&type=style&index=0&id=8200271a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8200271a"]])

export default __exports__